import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '.default-btn, .optional-btn, [appButtonHover]'
})
export class ButtonHoverDirective {

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('mouseenter', ['$event'])
    onMouseEnter(e: MouseEvent) {
        const parentOffset = this.el.nativeElement.getBoundingClientRect();
        const relX = e.pageX - (parentOffset.left + window.scrollX);
        const relY = e.pageY - (parentOffset.top + window.scrollY);

        const span = this.el.nativeElement.querySelector('span');
        if (span) {
            this.renderer.setStyle(span, 'top', relY + 'px');
            this.renderer.setStyle(span, 'left', relX + 'px');
        }
    }

    @HostListener('mouseout', ['$event'])
    onMouseOut(e: MouseEvent) {
        const parentOffset = this.el.nativeElement.getBoundingClientRect();
        const relX = e.pageX - (parentOffset.left + window.scrollX);
        const relY = e.pageY - (parentOffset.top + window.scrollY);

        const span = this.el.nativeElement.querySelector('span');
        if (span) {
            this.renderer.setStyle(span, 'top', relY + 'px');
            this.renderer.setStyle(span, 'left', relX + 'px');
        }
    }
}
